import React, { useEffect, useState } from "react";
import s from "./Plantilla.module.css";

//Servicios
import providersService from "../../../../api/providers/providersService";
import { formatJavaCompleto, formatJavaCompletossx, formatJavaCompletoSSS } from "../../../../config/strings";
import gamesService from "../../../../api/games/GamesService";

//Assets
import { dateFormats } from "../../../../helpers/convertDate";
import ConfigsSearcher from "../../../../config/Configs";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

//Material
import Grid from "@mui/material/Grid"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableContainer from "@mui/material/TableContainer"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import Typography from "@mui/material/Typography"
// Service
import { getAgencieById } from "../../../../api/agencies/AgenciesService";
// Utils
import { useNotificationContext } from "../../../Notifications/CustomNotifications";

// ============================= | PLANTILLA | =================================

export const Plantilla = ({ data, assetsReady }) => {
    
    const dates = dateFormats();
    const config = ConfigsSearcher();


  const notification = useNotificationContext();
  const { textColor } = useSelector((state) => state.local);
  const { currentLogo } = useSelector((state) => state.local);
  const { activeOrganization } = useSelector((state) => state.gamma);
  const currentUser = useSelector((state) => state.gamma.logged_user);

  const [logo, setLogo] = useState("");
  const [client, setClient] = useState(null);
  const [carrier, setCarrier] = useState(null);
  const [games, setGames] = useState([]);

  const { t } = useTranslation();

  // Obtener y formatear la fecha (campo "Fecha de alta")
  const getFormattedDate = (value) => {
    if (!value) return "-";
    
    try {
      // Si viene en formato ISO (2026-01-26T19:09:04.325274), extraer solo la fecha
      if (value.includes("T")) {
        const datePart = value.split("T")[0]; // "2026-01-26"
        const [year, month, day] = datePart.split("-");
        // Formatear como DD/MM/YYYY
        return `${day}/${month}/${year}`;
      }
      
      // Si ya viene formateada, intentar usar formatLocalDate
      let dateFormat;
      if (value.length > 23) {
        dateFormat = formatJavaCompletossx;
      } else if (value.length === 23) {
        dateFormat = formatJavaCompletoSSS;
      } else {
        dateFormat = formatJavaCompleto;
      }
      const formatted = dates.formatLocalDate(value, dateFormat);
      return formatted !== "-" ? formatted : "-";
    } catch (error) {
      console.error("❌ [Plantilla] Error al formatear fecha:", error);
      return "-";
    }
  };

  // Usar SOLO el campo date (Fecha de alta)
  console.log("🔍 [Plantilla] Fecha del remito (data.date):", data.date);
  let date = getFormattedDate(data.date);
  console.log("✅ [Plantilla] Fecha formateada:", date);

  const getCarrier = () => {
      if (data?.carrierId) {
        providersService
          .getSupplierById(data?.carrierId)
          .then((res) => setCarrier(res))
          .catch((error) => {
            notification.error("Error endpoint", error.message);
          });
      }
    };

  useEffect(() => {
    setLogo(currentLogo.imgBase64);
  }, [currentLogo]);

  useEffect(() => {
    console.log("🔍 [Plantilla] Datos del remito recibidos:", JSON.stringify(data, null, 2));
    console.log("🔍 [Plantilla] Estructura del remito:", {
      id: data?.id,
      type: data?.type,
      nroInput: data?.nroInput,
      nroOutput: data?.nroOutput,
      date: data?.date,
      agencyId: data?.agencyId,
      agency: data?.agency,
      supplierId: data?.supplierId,
      detailList: data?.detailList,
      detailListLength: data?.detailList?.length,
    });

    gamesService
      .getAllGames()
      .then((res) => setGames(res.content))
      .then(() => {
        // Intentar obtener el cliente (agencia o proveedor) desde múltiples fuentes
        const agencyId = data?.agencyId || data?.agency?.id || data?.agency_id;
        const supplierId = data?.supplierId || data?.supplier?.id || data?.supplier_id;
        
        console.log("🔍 [Plantilla] Buscando cliente - agencyId:", agencyId, "supplierId:", supplierId);
        
        if (supplierId) {
          providersService
            .getSupplierById(supplierId)
            .then((res) => {
              console.log("✅ [Plantilla] Proveedor encontrado:", res);
              setClient(res);
            })
            .then(() => getCarrier())
            .then(() => assetsReady(true))
            .catch((error) => {
              console.error("❌ [Plantilla] Error al obtener proveedor:", error);
              notification.error("Error endpoint", error.message);
            });
        } else if (agencyId) {
          getAgencieById(agencyId)
            .then((res) => {
              console.log("✅ [Plantilla] Agencia encontrada:", res);
              setClient(res);
            })
            .then(() => getCarrier())
            .then(() => assetsReady(true))
            .catch((error) => {
              console.error("❌ [Plantilla] Error al obtener agencia:", error);
              notification.error("Error endpoint", error.message);
            });
        } else {
          // Si no hay ni supplierId ni agencyId, intentar usar la información del remito directamente
          console.warn("⚠️ [Plantilla] No se encontró agencyId ni supplierId, usando datos del remito directamente");
          if (data?.agency) {
            setClient(data.agency);
          } else if (data?.supplier) {
            setClient(data.supplier);
          } else {
            setClient(null);
          }
          getCarrier();
          assetsReady(true);
        }
      })
      .catch((error) => {
        console.error("❌ [Plantilla] Error al obtener juegos:", error);
        notification.error("Error endpoint", error.message);
      });
  }, [data]);

  return (
    <Grid container className={s.remito}>
      <Grid container item xs={12} className={s.canvas}>
        <Grid container item xs={12} className={s.header}>
          <Grid container item xs={5.25} className={s.imageContainer}>
            <Grid item xs={12} className={s.image}>
              <img src={logo} alt="userImage" />
              <span>{currentUser?.memberships[0]?.organization?.name}</span>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                mt: 1,
                mb: 2,
                ml: 3,
              }}
            >
              <p>
                {`${config.configFinder("ORG_DIR")} - ${config.configFinder("ORG_LOC")}` ||
                  ""}
              </p>
              <p>
                {`CP: ${config.configFinder("ORG_CP")} - ${t("phone")}: ${config.configFinder("ORG_TEL")}` ||
                  ""}
              </p>
              <p>{`Email: ${config.configFinder("ORG_EMAIL")}` || ""}</p>
            </Grid>
          </Grid>
          <Grid
            item
            xs={1.5}
            className={s.label}
            sx={{ backgroundColor: "primary.dark", color: textColor }}
          >
            R
          </Grid>
          <Grid item xs={5.25} className={s.headerData}>
            <Grid
              item
              xs={12}
              className={s.title}
              sx={{
                backgroundColor: "primary.main",
                color: textColor,
                flexDirection: "column",
              }}
            >
              <p>{t("deliveryNote").toUpperCase()}</p>{" "}
              <span>{t("notInvoice")}</span>
            </Grid>
            <Grid
              item
              xs={12}
              className={s.title2}
              sx={{ backgroundColor: "primary.light", color: textColor }}
            >
            <p>
              {`N° ${data.type === "Entrada" 
                ? (data.nroInput || data.id || "-") 
                : (data.nroOutput || data.id || "-")}`}
            </p>
            </Grid>
            <Grid item container xs={12} className={s.dates}>
              <Grid
                item
                xs={3}
                className={s.date}
                sx={{ backgroundColor: "primary.main", color: textColor }}
              >
                {t("date")}
              </Grid>
              <Grid item xs={8} className={s.box}>
                <p>{date}</p>
              </Grid>
            </Grid>
            <Grid item container xs={12} className={s.data}>
              <Grid
                item
                xs={12}
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                <p>CUIT:</p>
                <p>{config.configFinder("ORG_CUIT") || "-"}</p>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid container item xs={12} className={s.client}>
          <Typography
            sx={{ backgroundColor: "primary.main", color: textColor }}
            className={s.h4}
          >
            {t("destinationAddress")}:
            <h2>
              {client?.businessName || 
               client?.name || 
               data?.agency?.name || 
               data?.agencyName || 
               data?.supplier?.name || 
               "-"}
            </h2>{" "}
            <p>
              CUIT: {client?.cuit || 
                     client?.cuiNumber || 
                     data?.agency?.cuiNumber || 
                     data?.supplier?.cuit || 
                     ""}
            </p>{" "}
            <p>
              {t("address")}:{" "}
              {client?.address?.street
                ? `${client?.address?.street || ""} ${client?.address?.number || ""}, ${client?.address?.location?.name || ""} - ${client?.address?.location?.province?.name || ""}`
                : client?.address
                ? `${client?.address || ""}, ${client?.location || ""} - ${client?.province || ""}`
                : data?.agency?.addressId
                ? `${data?.agency?.address?.street || ""} ${data?.agency?.address?.number || ""}, ${data?.agency?.address?.location?.name || ""} - ${data?.agency?.address?.location?.province?.name || ""}`
                : "-"}
            </p>
          </Typography>
        </Grid>

        <Grid container item xs={12} className={s.details}>
          <TableContainer className={s.tableContainer}>
            <Table>
              <TableHead sx={{ backgroundColor: "primary.light" }}>
                <TableCell sx={{ color: textColor }}>{t("quantity")}</TableCell>
                <TableCell sx={{ color: textColor }}>
                  {t("packages")}/{t("coupons")}
                </TableCell>
                <TableCell sx={{ color: textColor }}>{t("game")}</TableCell>
                <TableCell sx={{ color: textColor }}>
                  {t("serie")}/{t("drawNumber")}
                </TableCell>
                <TableCell sx={{ color: textColor }}>{t("price")}</TableCell>
                <TableCell sx={{ color: textColor }}>%P. Menor</TableCell>
              </TableHead>
              <TableBody>
                {data.detailList?.map((item, i) => {
                  // Buscar el juego - intentar múltiples formas
                  const gameId = item.gameId || item.game?.id || item.gameId;
                  const game = games.find((g) => 
                    g.modality?.game?.id === gameId || 
                    g.id === gameId ||
                    g.modality?.game?.id === item.game?.id
                  );
                  const gameName = game?.modality?.game?.name || item.game?.name || item.gameName || "-";
                  
                  // Obtener información del sorteo/rifa
                  const raffle = item.raffle || item.raffleReadDTO || {};
                  const raffleSerie = raffle.serie || raffle.serie || "-";
                  const raffleNumber = raffle.number || raffle.nroRaffle || "-";
                  const raffleIdentifier = raffleSerie !== "-" ? raffleSerie : raffleNumber;
                  
                  return (
                    <React.Fragment key={i}>
                      <TableRow>
                        <TableCell>{item.amount || "-"}</TableCell>
                        <TableCell>
                          {item.nroCouponFrom && item.nroCouponTo
                            ? `${item.nroCouponFrom}-${item.nroCouponTo}`
                            : item.coupons || "-"}
                        </TableCell>
                        <TableCell>{gameName}</TableCell>
                        <TableCell>{raffleIdentifier}</TableCell>
                        <TableCell>{raffle.price || item.price || "-"}</TableCell>
                        <TableCell>
                          {raffle.percentage || item.percentage || "0"}%
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>

        <Grid container item xs={12} className={s.observations}>
          <Grid item xs={11} className={s.text}>
            {`${t("observations")}: ${data.observations}`}
          </Grid>
          <Grid item xs={11} className={s.sign}>
            <p>{t("signature")} ..............................</p>
            <p>{t("clarification")} .........................</p>
          </Grid>
        </Grid>

        <Grid container item xs={12} className={s.client}>
          <Typography
            sx={{ backgroundColor: "primary.main", color: textColor }}
            className={s.h4}
          >
            {t("transport")}:<h2>{carrier?.businessName || ""}</h2>{" "}
            <p>CUIT: {carrier?.cuit || ""}</p>{" "}
            <p>
              {t("address")}:{" "}
              {carrier
                ? `${carrier?.address || ""} ${carrier?.numberAddress || ""} ${carrier?.location || ""}`
                : ""}
            </p>
          </Typography>
          <Grid item container xs={12} className={s.dataClient}>
            <Grid
              item
              xs={12}
              sx={{ display: "flex", justifyContent: "space-evenly" }}
            >
              <p>Tel: {carrier?.phone || ""}</p>
            </Grid>
          </Grid>
        </Grid>

        <Grid container item xs={12} className={s.cai}>
          <h2>CAI: {config.configFinder("CAI") || ""}</h2>
          <h2>
            {t("expirationDate")}: {config.configFinder("CAI_F_VTO") || ""}
          </h2>
        </Grid>
      </Grid>
    </Grid>
  );
};
